<h2 class="form__title">Add Comment</h2>

<ul class="table__control inline-list">
  <li>
    <button mat-raised-button (click)="onNoClick()" color="accent">Close</button>
  </li>
  <li>
    <button mat-raised-button [mat-dialog-close]="newComment" cdkFocusInitial
      [disabled]="!newComment|| newComment.length === 0" color="primary">Add</button>
  </li>
</ul>

<ng-form #alertForm="ngForm" novalidate class="form__cont">
  <h3 class="full__section">New Comment</h3>

  <mat-form-field appearance="outline" class="commentEntry">
    <mat-label>Comments</mat-label>
    <input #Comments="ngModel" name="Comments" matInput [(ngModel)]="newComment" maxlength="3000" />
  </mat-form-field>
</ng-form>
